module.exports = __webpack_public_path__ + "img/defpage_wuzhuanxiang@2x.433607b1.png";